import { render, staticRenderFns } from "./signatoryList.vue?vue&type=template&id=53a9d84c&scoped=true"
import script from "./signatoryList.vue?vue&type=script&lang=js"
export * from "./signatoryList.vue?vue&type=script&lang=js"
import style0 from "./signatoryList.vue?vue&type=style&index=0&id=53a9d84c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a9d84c",
  null
  
)

export default component.exports